


















































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { ApiError, User } from '@/api';
import TermsDialog from '@/components/TermsDialog.vue';
import CheckYourEmail from '@/components/auth/CheckYourEmail.vue';

@Component({
  components: { TermsDialog, CheckYourEmail },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  error: string = '';

  termsDialog: boolean = false;

  // Required acknowledgements: validated client-side only, never submitted.
  acknowledgedBidding: boolean = false;
  acknowledgedAge: boolean = false;

  // Registration does not log the user in; it hands over to a "check your
  // email" state in place of the form.
  registered: boolean = false;
  registeredEmail: string = '';

  user = {
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    firstName: '',
    lastName: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    state: 'Tasmania',
    postCode: null,
    // Required, and deliberately not pre-checked. The server rejects false as a
    // validation error rather than treating it as a silent no-op.
    acceptedTerms: false,
  };

  termsRules = [
    (v: boolean) => v === true || 'You must accept the terms and conditions',
  ];

  biddingRules = [
    (v: boolean) =>
      v === true || 'You must acknowledge your liability when bidding',
  ];

  ageRules = [
    (v: boolean) => v === true || 'You must be over the age of 18',
  ];

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThan(0)
        .test(Number(v)) || 'This field is required',
  ];

  phoneRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Phone number is required',
    (v: string) =>
      v8n()
        .string()
        .pattern(/^[0-9]{10}$/)
        .test(v) || 'Phone number must be 10 digits',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  passwordRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Password required',
    (v: string) =>
      v8n()
        .string()
        .minLength(8)
        .test(v) || 'Password must be at least 8 chars',
    (v: string) =>
      v8n()
        .not.numeric()
        .minLength(8)
        .test(v) || 'Password must include non-numeric chars',
  ];

  get passwordRules2() {
    return [
      (v: string) =>
        v8n()
          .string()
          .not.empty()
          .test(v) || 'Password required',
      (v: string) => this.user.password === v || 'Passwords do not match',
    ];
  }

  stateOptions = [
    'Australian Capital Territory',
    'New South Wales',
    'Northern Territory',
    'Queensland',
    'South Australia',
    'Tasmania',
    'Victoria',
    'Western Australia',
  ];

  clear() {
    this.user = {
      email: '',
      password: '',
      confirmPassword: '',
      phone: '',
      firstName: '',
      lastName: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      state: 'Tasmania',
      postCode: null,
      acceptedTerms: false,
    };
    this.acknowledgedBidding = false;
    this.acknowledgedAge = false;
    this.registered = false;
    this.registeredEmail = '';
    this.error = '';

    // @ts-ignore
    if (this.$refs.registerForm) {
      // @ts-ignore
      this.$refs.registerForm.resetValidation();
    }
  }

  async register() {
    this.loading = true;
    try {
      await User.register(this.user);
      this.registeredEmail = this.user.email;
      this.registered = true;
      this.error = '';
      this.$emit('register-success');
    } catch (e) {
      this.error = e.response ? e.response.errors[0].detail : 'Unknown error';
    } finally {
      this.loading = false;
    }
  }
}
